import Embed from "@editorjs/embed";

class CustomEmbedWithExtraInput extends Embed {
  render() {
    const wrapper = super.render();

    // 새 인풋 생성
    const extraInput = document.createElement("input");
    extraInput.type = "text";
    extraInput.placeholder = "비율을 입력하세요 (예: 9/16)";
    extraInput.className = "cdx-input custom-extra-caption";
    extraInput.value = this.data?.extraCaption || "";

    // 하단에 삽입
    wrapper.appendChild(extraInput);

    // 저장 시 접근할 수 있도록 인스턴스에 저장
    this.extraInputEl = extraInput;

    return wrapper;
  }

  save(blockContent) {
    // 기본 저장 데이터
    const baseData = super.save(blockContent);

    // 추가 input 내용 저장
    return {
      ...baseData,
      extraCaption: this.extraInputEl?.value || ""
    };
  }
}

export default CustomEmbedWithExtraInput;
